<!-- ANGULAR 12 MIGRATED COMPONENT -->

<!-- Standard Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (isLoading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!isLoading) {
<form name="tbl3" novalidate>
    <div class="panel panel-default" style="margin-top:12px">
      <div class="panel-body">
        <div class="form-group">
          <!-- Tax Year & Activate row -->
          <div class="form-row">
            <div class="col-label">
              <label class="form-label" for="taxYear">Tax Year*</label>
            </div>
            <div class="col-input col-sm-width">
              <select class="form-control"
                      id="taxYear"
                      name="taxYear"
                      [ngModel]="selectedTaxYear"
                      (ngModelChange)="selectedTaxYear = $event; onTaxYearChanged()"
                      [disabled]="mode === 'edit'"
                      required>
                @for (ty of taxYears; track $index) {
<option [ngValue]="ty">{{ ty.label }}</option>
}
              </select>
            </div>
            <div class="col-label">
              <label for="activate">Activate</label>
            </div>
            <div class="col-input col-sm-width">
              <input id="activate"
                     class="form-control form-control-checkbox"
                     type="checkbox"
                     [(ngModel)]="activate"
                     name="activate">
            </div>
          </div>

          <!-- CBC Summary Value row -->
          <div class="form-row">
            <div class="col-label">
              <label for="elements-dropdown">CBC Summary Value*</label>
            </div>
            <div class="col-input col-sm-width">
              <ap-dropdown class="field-full-width" [list]="summaryDropdownItems" [selectType]="'single'"
                inputId="elements-dropdown" [title]="'CBC Summary Value'" [hideTitleOnInput]="true" [inputAriaLabel]="'CBC Summary Value'"
                [disabled]="elementsLoading"
                [(ngModel)]="selectedElementItem" [ngModelOptions]="{standalone: true}"
                (onSelect)="onSummaryDropdownSelect($event)">
                @for (item of summaryDropdownItems; track $index) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setDropdownAriaLabel(item, 'CBC Summary Value')"
                    (onSelectItem)="onSummarySelectItem($event)"></ap-dropdown-list-item>
                }
              </ap-dropdown>
              @if (showCbcSummaryEleRequiredError) {
<span class="form-error-container"
                   >CBC Summary Value is required.</span>
}
            </div>
          </div>

          <!-- CBC Summary Input row -->
          <div class="form-row summary-input-row">
            <div class="col-label">
              <label for="summary-input">CBC Summary Input</label>
            </div>
            <div class="col-input">
              <textarea id="summary-input"
                        class="form-control"
                        name="cbcSummaryInput"
                        [(ngModel)]="summaryInput"
                        cols="100"></textarea>
            </div>
          </div>

          <!-- Applied Jurisdictions & Apply To All row -->
          <div class="form-row">
            @if (!hideJurisSelection) {
<div class="col-label">
              <label>Applied Jurisdictions*</label>
            </div>
}
            @if (!hideJurisSelection) {
<div class="col-input col-sm-width">
              <div class="juris-dropdown">
                <div class="juris-dropdown-toggle"
                     [class.disabled]="jurisLoading || jurisdictions.length === 0"
                     (click)="jurisDropdownOpen = !jurisDropdownOpen">
                  <span class="juris-btn-text">
                    {{ selectedJuris.length > 0 ? selectedJuris.length + ' selected' : 'Select jurisdictions' }}
                  </span>
                  <span class="caret"></span>
                </div>
                @if (jurisDropdownOpen) {
<div class="juris-dropdown-menu">
                  <div class="juris-dropdown-actions">
                    <a (click)="selectAllJuris()">Select all</a> |
                    <a (click)="unselectAllJuris()">Unselect all</a>
                  </div>
                  <div class="juris-dropdown-list">
                    @for (juris of jurisdictions; track $index) {
<div
                         class="juris-dropdown-item"
                         (click)="toggleJuris(juris)">
                      <input type="checkbox"
                             [checked]="isJurisSelected(juris)"
                             (click)="$event.stopPropagation(); toggleJuris(juris)">
                      <span>{{ juris.COUNTRY }}</span>
                    </div>
}
                  </div>
                </div>
}
              </div>
              @if (showAppliedJurisRequiredError) {
<span class="form-error-container"
                   >Applied Jurisdictions are required.</span>
}
            </div>
}
            <div class="col-label">
              <label for="applyToAllJuris">Apply To All Jurisdictions?</label>
            </div>
            <div class="col-input col-sm-width">
              <input id="applyToAllJuris"
                     class="form-control form-control-checkbox"
                     type="checkbox"
                     [checked]="applyToAllJuris"
                     (click)="onApplyToAllJurisCheckboxChecked($event)"
                     [disabled]="!jurisdictions.length || jurisLoading"
                     name="applyToAllJuris">
            </div>
          </div>

        </div>
      </div>
    </div>
  </form>
}
</div>

<!-- Standard Footer -->
<div class="modal-footer" [hidden]="minimise">
  @if (mode !== 'create') {
<button
          class="delete-button"
          type="button"
          [disabled]="crudLoading"
          (click)="delete()">
    @if (deleting) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Delete
  </button>
}
  <button class="save-button"
          type="button"
          [disabled]="isFormInvalid || crudLoading"
          (click)="save()">
    @if (saving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>
